import { createFileRoute } from '@tanstack/react-router';
import Contracts from 'src/pages/Organization/Branches/Contracts';

export const Route = createFileRoute(
  '/$organizationSlug/branches/$branchId/contracts',
)({
  component: Contracts,
});
